
const ListTable = require('app/ui/list/Table');

class OrderCountView {

    defaultOptions(){
        return {
            'tabId': 'orderCountViewTab',
            'graphTabLinkId': 'orderCountViewGraphLinkTab',
            'graphTabId': 'orderCountViewGraphTab',
            'dataTabLinkId': 'orderCountViewDataLinkTab',
            'dataTabId': 'orderCountViewDataTab',
            '$container': null,
            'data': null,
            'product': null,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.data = this.settings.data;
        this.product = this.settings.product;
        this.initialize();
    }

    initialize() {
        var self = this;

        this.$container
        .html('')
        .append(this.buildHeader())
        .append(this.buildTabs())
        .append(this.buildTabsContent());

        this.fillGraphContent();
        this.fillDataContent();
    }

    buildHeader(){
        let $header = $("<h3/>")
        .addClass('box-title')
        .append(window.translate('app.product.show.tabs.stat.orderCountView.title'))

        return $header;
    }

    buildTabs(){
        let $tabs = $('<ul/>')
        .addClass('nav nav-tabs')
        .attr('role',"tablist")
        .attr('id',this.settings.tabId);


        let $graphTabLink = $("<li/>")
        .addClass('nav-item')
        .attr('role','presentation')
        .append(
            $("<button/>")
            .addClass('nav-link active')
            .attr('type','button')
            .attr('data-bs-toggle','tab')
            .attr('role','tab')
            .attr('aria-selected',true)
            .attr('data-bs-target','#'+this.settings.graphTabId)
            .attr('id',this.settings.graphTabLinkId)
            .append(
                $('<i/>')
                .addClass('fas fa-chart-line me-1')
            )
            .append(window.translate('app.product.show.tabs.stat.graph.title'))
        );


        let $dataTabLink = $("<li/>")
        .addClass('nav-item')
        .attr('role','presentation')
        .append(
            $("<button/>")
            .addClass('nav-link')
            .attr('type','button')
            .attr('data-bs-toggle','tab')
            .attr('role','tab')
            .attr('aria-selected',false)
            .attr('data-bs-target','#'+this.settings.dataTabId)
            .attr('id',this.settings.dataTabLinkId)
            .append(
                $('<i/>')
                .addClass('fas fa-th-list me-1')
            )
            .append(window.translate('app.product.show.tabs.stat.data.title'))
        );

        $tabs
        .append($graphTabLink)
        .append($dataTabLink)

        return $tabs;
    }

    buildTabsContent(){
        let $tabContents = $('<div/>')
        .addClass('tab-content')
        .addClass('p-2');

        this.$graphContent = $("<div/>");
        this.$dataContent = $("<div/>");

        let $graphTab = $('<div/>')
        .attr('id',this.settings.graphTabId)
        .attr('role','tabpanel')
        .attr('aria-labelledby',this.settings.graphTabLinkId)
        .addClass('tab-pane fade show active')
        .append(
            $('<div/>')
            .addClass('tab-body')
            .append(this.$graphContent)
        )

        let $dataTab = $('<div/>')
        .attr('id',this.settings.dataTabId)
        .attr('role','tabpanel')
        .attr('aria-labelledby',this.settings.dataTabLinkId)
        .addClass('tab-pane fade')
        .append(
            $('<div/>')
            .addClass('tab-body')
            .append(this.$dataContent)
        )

        $tabContents
        .append($graphTab)
        .append($dataTab)

        return $tabContents;
    }

    computeToGraphData(data){

    }

    fillGraphContent(){
        let chartId = window.uniqid();
        let $chart = $('<canvas/>')
        .attr('id',chartId);

        this.$graphContent
        .html('')
        .append($chart);

        let computedData = window.computeXYDataToGraphData(
            this.data,
            function(label){
                let splitedMonth = label.split('-');
                let monthLabel = window.translate('month'+parseInt(splitedMonth[1]));
                return monthLabel + ' ' + splitedMonth[0];
            },
            function(value){
                return value;
            }
        );

        let chartConfig = {
            'type': 'line',
            'options': {
                'plugins':{
                    'legend':{
                        'display': false,
                    }
                }

            },
            'data': {
                'labels': computedData.labels,
                'datasets': [{
                    'label': '',
                    'backgroundColor': 'rgb(0, 187, 217)',
                    'borderColor': 'rgb(0, 187, 217)',
                    'data': computedData.data,
                }]
            }
        };

        let chart = new Chart(
            document.getElementById(chartId),
            chartConfig
        );
    }

    fillDataContent(){
        var self = this;
        let total = 0;
        for(var i in this.data){
            let current = parseFloat(this.data[i].y);
            total += current;
        }

        let $footerContent = $("<tr/>")
        .append(
            $('<th/>')
            .append(window.translate('total'))
        )
        .append(
            $('<th/>')
            .append(window.formatFloat(total,2) + ' ' + this.product.unit)
        )

        this.table = new ListTable({
            '$container': this.$dataContent,
            'tableClass': 'table table-striped',
            'id': 'ordercount-list',
            'length': 0,//unlimited
            'data': this.data,
            'footerContent': $footerContent,
            'columns': [
                {
                    'name': 'month',
                    'label': window.translate('month'),
                    'class': 'month',
                    'render': function(item,index){
                        let splitedMonth = item.x.split('-');
                        let monthLabel = window.translate('month'+parseInt(splitedMonth[1]));
                        return monthLabel + ' ' + splitedMonth[0];
                    },
                },
                {
                    'name': 'total',
                    'label': window.translate('total'),
                    'class': 'total',
                    'render': function(item,index){
                        return window.formatFloat(item.y,2) + ' ' + self.product.unit;
                    },
                }
            ]
        });
    }

}

module.exports = OrderCountView;

